import { ApiEndpoints } from "./api-endpoints.interface";

export const endpoints: ApiEndpoints = {
  disclosure: {
    getDisclosures: 'disclosures',
  },

  member: {
    addMemberDisclosures: 'member/${memberId}/disclosure',
    getMemberDisclosures: 'member/${memberId}/disclosure',
    saveAllMemberDisclosures: 'member/disclosure',
  },

  users: {
    getUsers: 'admin/users/list',
    getUserById: 'admin/users/${userId}',
  },

  sme: {
    getAllSmeUsers: 'admin/app',
    getSmeUsersById: 'admin/app/id/${smeUserId}',
    getSmeUsersByAppId: 'admin/app/refId/${appId}',
    getAllSme: 'admin/sme',
    getSmeById: 'admin/sme/${smeId}',
    getAllMembers: 'admin/members',
    getMembersBySmeId: 'sme/${appId}/members',
  },

  quotationGroups: {
    getQuotationGroups: 'admin/quot-groups',
    getQuotationGroupsList: 'admin/quot-groups/list',
    getQuotationGroupById: 'admin/quot-groups/${quotationGroupId}',

    // Sync data
    startSyncData: 'admin/quot-groups/sync-data/${processId}',
    createSyncDataProcess: 'admin/quot-groups/sync-data',
    getSyncDataProcessList: 'admin/quot-groups/sync-data',
    getSyncDataProcessById: 'admin/quot-groups/sync-data/${processId}',
    getSyncDataStatus: 'admin/quot-groups/sync-data/${processId}',

    // Data
    getBenefitsDataByProvider: 'admin/quot-groups/benefits-data/provider/${providerId}',
    getBenefitsDataByCCHICode: 'admin/quot-groups/benefits-data/code/${cchiCode}',
    getBenefitsData: 'admin/quot-groups/benefits-data',
    getNetworksDataByProvider: 'admin/quot-groups/network-data/provider/${providerId}',
    getNetworksData: 'admin/quot-groups/network-data',
  },

  quotations: {
    getQuotations: 'admin/quotations',
    getQuotationsByGroup: 'admin/quot-groups/${quotGroupId}/quotations',
    getQuotationByGroupAndId:
      'admin/quot-groups/${quotGroupId}/quotations/${quotationId}',
    getQuotationById: 'admin/quotations/${quotationId}',
  },

  orders: {
    getOrders: 'admin/orders',
    getOrdersById: 'admin/orders/${orderId}',
  },

  payments: {
    getPayments: 'admin/payments',
    getPaymentsById: 'admin/payments/${transactionId}',
  },

  policy: {
    getPolicies: 'admin/policy',
    getPolicyById: 'admin/policy/${policyId}',
  },

  insProviders: {
    // Providers
    getInsProviders: 'admin/insurance-providers',
    getInsProvidersInfo: 'insurance-providers/info',
    getInsProviderById: 'admin/insurance-providers/${id}',
    getInsProviderByIpId: 'admin/insurance-providers/${providerId}',
    getEnumList: 'admin/insurance-providers/list/${listName}',

    // Endpoints
    getInsProviderEndpointById:
      'admin/insurance-providers/endpoints/${endpointId}',
    getInsProviderEndpointsByProviderId:
      'admin/insurance-providers/${providerId}/endpoints',

    // Docs
    getAllInsProviderDocs: 'admin/insurance-providers-docs',
    getInsProviderDocsByProviderAndDocType:
      'admin/insurance-providers-docs/provider/${providerId}/docType/${docType}',
    uploadInsProviderDoc: 'admin/insurance-providers-docs/upload',
    getDownloadUrlByDocId:
      'admin/insurance-providers-docs/${docId}/download-url',
    getAvailableMonths:
      'admin/insurance-providers-docs/available-months/${providerId}/${docType}',
    getActiveDoc:
      'admin/insurance-providers-docs/active-doc/${providerId}/${docType}',
    deleteDocById:
      'admin/insurance-providers-docs/${docId}',
  },
};